import axios from 'axios';
import APIS from '../../apis';
import CIKE_APIS from '../../apis/cike';
import qs from 'qs';
import {
  callbackHandler,
} from '../callbackHandler';

export default {
  state: {
    consultWaitDays: 0, // 咨询师等待的天数
    consultWaitHours: 0, // 咨询师等待的小时数
    bindMobileStatus: undefined, // 手机号绑定状态
    bindMobileNumber: '', // 绑定手机号
  },
  mutations: {
    setConsultWaitDays(state, val) {
      state.consultWaitDays = val
    },

    setConsultWaitHours(state, val) {
      state.consultWaitHours = val
    },

    setBindMobileStatus(state, val) {
      state.bindMobileStatus = val
    },

    setBindMobileNumber(state, val) {
      state.bindMobileNumber = val
    }
  },
  getters: {
    consultWaitDays: state => state.consultWaitDays,
    consultWaitHours: state => state.consultWaitHours,
    bindMobileStatus: state => state.bindMobileStatus,
    bindMobileNumber: state => state.bindMobileNumber
  },
  actions: {
      notLoginCheckBindMobile(context, params) {
      return axios.get(APIS.notLoginCheckBindMobile, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.notLoginCheckBindMobile, res);
        return res.data;
      })
    },
    checkBindMobile(context, params) {
      return axios.get(APIS.checkBindMobile, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.checkBindMobile, res);
        return res.data;
      })
    },
    getConsultToken(context, params) {
      return axios.get(APIS.getConsultToken, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.getConsultToken, res);
        return res.data;
      })
    },
    consultSendValidcode(context, params) {
      return axios.get(APIS.consultSendValidcode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.consultSendValidcode, res);
        return res.data;
      })
    },
    notLoginconsultBindUserMobile(context, params) {
      return axios.get(APIS.notLoginconsultBindUserMobile, {
          params: params.params
      }).then(function (res) {
          callbackHandler(APIS.notLoginconsultBindUserMobile, res);
          return res.data;
      })
    },
    consultBindUserMobile(context, { API, params}) {
      return axios.get(API, {
        params
      }).then(function (res) {
        callbackHandler(API, res);
        return res.data;
      })
    },
    syncByUserKey(context, params){
      return axios.post(APIS.syncByUserKey, qs.stringify(params.params))
        .then(function (res) {
          callbackHandler(APIS.syncByUserKey, res);
          return res.data;
        })
    },
    syncByOrder(context, params){
      return axios.post(APIS.syncByOrder, qs.stringify(params.params))
        .then(function (res) {
          callbackHandler(APIS.syncByOrder, res);
          return res.data;
        })
    },
    syncByOrderNo(context, params){
      return axios.post(APIS.syncByOrderNo, qs.stringify(params.params))
        .then(function (res) {
          callbackHandler(APIS.syncByOrderNo, res);
          return res.data;
        })
    },
    fetchConsultantInfos(context, params) {
      return new Promise((resolve, reject) => {
        axios.get(APIS.fetchConsultantInfos, {
          params: params.params
        }).then(function (res) {
          callbackHandler(APIS.fetchConsultantInfos, res);
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    fetchConsultPrices(context, params) {
      return new Promise((resolve, reject) => {
        axios.get(APIS.fetchConsultPrices, {
          params: params.params
        }).then(function (res) {
          callbackHandler(APIS.fetchConsultPrices, res);
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    fecthNotCompleteCount(context, params){
      return axios.get(CIKE_APIS.fecthNotCompleteCount, {
        params: params.params
      }).then(function (res) {
        callbackHandler(CIKE_APIS.fecthNotCompleteCount, res);
        return res.data;
      })
    },
    fecthConsultStatus(context, params) {
      return axios.get(APIS.consultStatus, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.consultStatus, res);
        return res.data;
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/consult.js